<template>
    <div @click="clickEvent">
		<page-nav :navlist="navlist" :fullpage="fullpage"></page-nav>
		<div class="home-wrap">
			<top-page class="home-page"></top-page>
			<!-- <pre-reg class="home-page"></pre-reg>
			<pre-result class="home-page"></pre-result> -->
			<!-- <pre-reward class="home-page"></pre-reward> -->
			<!-- <sns-share class="home-page"></sns-share> -->
			<character class="home-page"></character>
			<story class="home-page"></story>
			<gallery class="home-page"></gallery>
			<footer-bar class="home-page"></footer-bar>
		</div>
	</div>
</template>

<script>
import "../plugins/fullpage.min.js"
import topPage from "../pages/home/Top"
import PreReg from "../pages/home/PreReg"
import PreResult from "../pages/home/PreResult"
// import PreReward from "../pages/home/PreReward"
import SnsShare from "../pages/home/SnsShare"
import Character from "../pages/home/Character"
import Story from "../pages/home/Story"
import Gallery from "../pages/home/Gallery"
import FooterBar from "../components/Footer"

import pageNav from "../components/Nav"

export default {
    name: "home",

    components: {
		topPage,
		pageNav,
		PreReg,
		PreResult,
		// PreReward,
		SnsShare,
		Character,
		Story,
		Gallery,
		FooterBar
	},
    data: () => ({
		
		fullpage: null,
		navlist: [
			{
                text: "메인"
            },
            // {
            //     text: "사전예약"
			// },
			// {
			// 	text: "사전예약자수 확인"
			// },
			/* {
                text: "사전예약 보상"
			}, */
			// {
			// 	text: "이벤트"
			// },
			{
				text: "오퍼레이터"
			},
			{
				text: "세계관"
			},
			{
				text: "갤러리"
			}
		]
    }),
    created() {
	},
    mounted() {
		this.fullpage = new FullPage({
			containerClassName: ".home-wrap",
			pageClassName: ".home-page",
			lastBar: true,
			disableSrcollClassName: []
		})
		this.fullpage.init()
		this.$store.commit("Home/INIT_FULLPAGE", this.fullpage);
	},
    watch: {},
    computed: {
	},
    methods: {
		clickEvent() {
			// 全局点击时，关闭导航栏
			this.$store.commit("Nav/SET_NAVBTN_ACTIVED", false);
		}
	}
};
</script>

<style lang="scss" scoped>
.home-wrap {
	width: 100%;
	.home-page {
		width: 100%;
		height: 100%;
		overflow: hidden;
		position: relative;
	}
}
</style>
